module.exports = __webpack_public_path__ + "assets/images/pages/medipremium/medipremium-header.png?6b72479a";